import { FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 * This type is the combination of workspace and company
 * The purpose of it is to remove the confusion between using company or workspaces
 * and have a unique type that covers both the workspaces and companies
 */
export type SdbCompany = Pick<
  FaroCoreApiTypes.CompanyWithRoleDetails,
  "domain" | "id" | "logoUrl" | "name" | "tags"
> &
  Pick<FaroCoreApiTypes.Workspace, "apiUrl" | "type" | "url"> & {
    role: {
      /** Role of user in company. Optional if workspace type is admin */
      company?: FaroCoreApiTypes.CompanyRole;

      /** Role of user in workspace */
      workspace: FaroCoreApiTypes.WorkspaceRole;
    };

    /** Defines that this company was migrated from Sphere Legacy */
    isSphereLegacyMigrated: boolean;

    /** Category of the workspace (e.g. customer, partner, internal) */
    companyCategory: FaroCoreApiTypes.CompanyTypeKind;
  };

/** Defines the available options for opening the project. */
export enum ProjectLaunchTarget {
  /** Open the project in the Sphere Viewer */
  sphereViewer = "SphereViewer",

  /** Open the project in the WebEditor */
  webEditor = "WebEditor",
}
